import { render, staticRenderFns } from "./CalendarEvents.vue?vue&type=template&id=02d3c2fa&"
import script from "./CalendarEvents.vue?vue&type=script&lang=js&"
export * from "./CalendarEvents.vue?vue&type=script&lang=js&"
import style0 from "./CalendarEvents.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports